import { useCallback } from "react";
import useNavigationUrlFactory from "@src/hooks/useNavigationUrlFactory";
import { useRollingStartNavigation } from "@src/lib/rolling-start-navigation";
import hasWindow from "@src/utils/hasWindow";

/** Sortie LP plein écran (web uniquement : pas de deeplink / pas de logique native apps). */
export default function useWidgetLpExitNavigation() {
  const { navigate, goBack } = useRollingStartNavigation();
  const routes = useNavigationUrlFactory();

  const exitLandingPage = useCallback(() => {
    if (!hasWindow()) return;
    if (window.history.length > 1) { 
      goBack();
      return;
    } 
    navigate(routes.home());
  }, [goBack, navigate, routes]);

  return exitLandingPage;
}
